<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2022-06-13 15:50:56
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-06-14 14:10:17
-->
<template>
  <el-select clearable v-model="hospitalId" :style="{width:width}"  @change="getChooseHospitalId" :disabled="disabled" @clear="clearVal" filterable remote :remote-method="remoteMethod"
    :loading="loading" :placeholder="placeholder" :size="size">
    <el-option v-for="item in hospitalList" :key="item.id" :label="item.name" :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
import { findHospitalByKeyWord } from "@/api/serviceOrder.js";
export default {
  data() {
    return {
      hospitalId: "",
      hospitalList: [],
      loading: false,
      hospitalName:""
    };
  },
  props: {
    placeholder: {
      type: String,
      default: "请选择线下机构"
    },
    size: {
      type: String,
      require:false,
      default: ""
    },
    disabled:{
      type: Boolean,
      require:false,
      default: false
    },
    width:{
      type: String,
      require:false,
      default:""
    },
    hospital:{
      type: Object||Array,
      require:false,
      default: () => {}
    }
  },
  watch:{
    // hospital
    hospital: {
      //添加
      handler(newval) {
        if (newval) {
          this.hospitalId = newval.id;
          
          this.hospitalList.push(newval);
          
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.getHospitalList(query);
      } else {
        this.hospitalList = [];
      }
    },
    getHospitalList(keyword) {
      let temp = {
        keyword: keyword,
        draft: this.draft
      };
      findHospitalByKeyWord(temp).then(res => {
        this.loading = false;
        this.hospitalList = res.data;
      });
    },
    clearVal() {
      this.getHospitalList();
    },
    resettingVal(){
      this.hospitalId="";
      this.getHospitalList();
    },
    getChooseHospitalId(val){
      this.hospitalList.forEach(item=>{
        if(item.id==val){
         this.hospitalName=item.name
        }
       })
       this.$emit("getChooseHospitalId", val, this.hospitalName);
    }
  }
};
</script>